<app-abstract-dialog
        [dialogWidth]="'800'"
        [ttsIconState]=ttsIconState
        [playButtonActive]=playButtonActive
        [repeatButtonActive]=repeatButtonActive
        (playAudioEvent)="playAudio()"
        (readTextEvent)="readText()">
    <h3 abstract-header class="abstract-dialog__header__title">{{ data.title }}</h3>
    <ng-container abstract-content>
        <div #focusArrow [hidden]="!hasImages()" class="abstract-dialog__content__image">
            <carousel #showImage class="carousel-slider" [cellWidth]="'100%'" [cellsToShow]="1"
                      [dots]="showNavigation()" [arrows]="showNavigation()">
                <app-popup-image class="carousel-cell" *ngFor="let imageId of imageIds"
                                 [imageId]="imageId"
                                 [indicationId]="data.indicationId"
                                 [textSize]="textSize">
                </app-popup-image>
            </carousel>
        </div>
        <div class="abstract-dialog__content__text content__text__info {{textSize}}"
             [innerHTML]="description">
        </div>
    </ng-container>
</app-abstract-dialog>
